<template>
    <div id="DeviceMap">
        <mu-appbar :z-depth="0" class="top_nav">
            <mu-flex>
                <mu-flex fill align-items="center" justify-content="center" class="brand_info">
                    <img v-if="$store.state.lang =='zh' || $store.state.lang =='zh-CN'" src="@/assets/image/logo.png"/>
                    <img v-else src="@/assets/image/logo_en.png"/>
                </mu-flex>
            </mu-flex>
            <mu-flex slot="right" class="top_right" align-items="center" >
                <span class="current_date">{{currentDate | formatDateForAMPM}}</span>
                <span class="divider_vert"></span>
                <mu-button small flat color="white" style="margin-right:16px;" to="/main"><mu-icon value="exit_to_app" left></mu-icon>{{$t('deviceMap.returnHome')}}</mu-button>
            </mu-flex>
        </mu-appbar>
        <mu-container fluid>
            <mu-row gutter>
                <mu-col :span="8">
                    <mu-paper class="index_paper" ref="map_container">
                        <div id="bmap" ref="bmap" style="position:relative;overflow:hidden;width:100%;" :style="{height: insideMapHeight}"></div>
                        <mu-flex justify-content="center" align-items="center" v-if="loadingPosition"
                            :style="{height: '100%'}" class="loading_block">
                            <lottie :options="defaultOptions" class="loadding"/>
                        </mu-flex>
                    </mu-paper>
                </mu-col>
                <mu-col :span="4">
                    <mu-paper class="index_paper">
                        <mu-flex direction="column" style="height:100%;">
                            <mu-flex class="right_block_item" direction="column">
                                <mu-flex align-items="center" align-self="stretch" style="margin-top:24px" class="play_value">
                                    <mu-flex direction="column" justify-content="center" align-items="center" style="width:50%;height:100%;">
                                        <p class="value" style="font-size:36px;">{{registerDeviceList.length}}</p>
                                        <span class="label">{{$t('deviceMap.registeredDevice')}}</span>
                                    </mu-flex>
                                    <mu-flex direction="column" justify-content="center" align-items="center" style="width:50%;height:100%;">
                                        <p class="value" style="font-size:36px;">{{allDeviceCount}}</p>
                                        <span class="label">{{$t('deviceMap.allDevice')}}</span>
                                    </mu-flex>
                                </mu-flex>
                            </mu-flex>
                            <mu-flex class="right_block_item" direction="column" align-items="between">
                                <mu-flex class="linear_progress" justify-content="between" align-items="center" align-self="stretch">
                                    <mu-linear-progress mode="determinate" :size="16" :value="notRegisterDeviceList.length" :max="allDeviceCount"
                                        color="green" style="width:64%;"></mu-linear-progress>
                                    <mu-flex>
                                        <span style="color:#ffffff;font-size:14px;font-family: LCD-N;">
                                            {{'(' + notRegisterDeviceList.length + ' / ' +  allDeviceCount + ')'}}
                                        </span>
                                        <span style="color:#ffffff;font-size:14px;margin-left:4px;">{{$t('deviceMap.factory')}}</span>
                                    </mu-flex>
                                </mu-flex>
                                <mu-flex class="linear_progress" justify-content="between" align-items="center" align-self="stretch">
                                    <mu-linear-progress mode="determinate" :size="16" :value="registerDeviceList.length" :max="allDeviceCount"
                                        color="primary" style="width:64%;"></mu-linear-progress>
                                    <mu-flex>
                                        <span style="color:#ffffff;font-size:14px;font-family: LCD-N;">
                                            {{'(' + registerDeviceList.length + ' / ' +  allDeviceCount + ')'}}
                                        </span>
                                        <span style="color:#ffffff;font-size:14px;margin-left:4px;">{{$t('deviceMap.registered')}}</span>
                                    </mu-flex>
                                </mu-flex>
                                <mu-flex class="linear_progress" justify-content="between" align-items="center" align-self="stretch">
                                    <mu-linear-progress mode="determinate" :size="16" :value="maintainCount" :max="allDeviceCount"
                                         color="warning" style="width:64%;"></mu-linear-progress>
                                    <mu-flex>
                                        <span style="color:#ffffff;font-size:14px;font-family: LCD-N;">
                                            {{'(' + maintainCount + ' / ' +  allDeviceCount + ')'}}
                                        </span>
                                        <span style="color:#ffffff;font-size:14px;margin-left:4px;">{{$t('deviceMap.maintenance')}}</span>
                                    </mu-flex>
                                </mu-flex>
                                <mu-flex class="linear_progress" justify-content="between" align-items="center" align-self="stretch">
                                    <mu-linear-progress mode="determinate" :size="16" :value="scrapCount" :max="allDeviceCount"
                                         color="red" style="width:64%;"></mu-linear-progress>
                                    <mu-flex>
                                        <span style="color:#ffffff;font-size:14px;font-family: LCD-N;">
                                            {{'(' + scrapCount + ' / ' +  allDeviceCount + ')'}}
                                        </span>
                                        <span style="color:#ffffff;font-size:14px;margin-left:4px;">{{$t('deviceMap.scrapped')}}</span>
                                    </mu-flex>
                                </mu-flex>
                                <mu-flex class="linear_progress" justify-content="between" align-items="center" align-self="stretch">
                                    <mu-linear-progress mode="determinate" :size="16" :value="loseCount" :max="allDeviceCount"
                                         color="grey" style="width:64%;"></mu-linear-progress>
                                    <mu-flex>
                                        <span style="color:#ffffff;font-size:14px;font-family: LCD-N;">
                                            {{'(' + loseCount + ' / ' +  allDeviceCount + ')'}}
                                        </span>
                                        <span style="color:#ffffff;font-size:14px;margin-left:4px;">{{$t('deviceMap.lose')}}</span>
                                    </mu-flex>
                                </mu-flex>
                            </mu-flex>
                            <mu-flex class="right_block_item" direction="column">
                                <mu-flex style="width:100%;height:100%">
                                    <IEcharts :options="pieOption" autoresize theme="light" style="width:60%;height:100%"></IEcharts>
                                    <mu-flex direction="column" justify-content="center" align-items="center" style="width:40%;height:100%" class="sum_info">
                                        <p>{{$t('deviceMap.online')}}: <span>{{onlineCount}}</span></p>
                                        <p>{{$t('deviceMap.offline')}}: <span>{{offlineCount}}</span></p>
                                    </mu-flex>
                                </mu-flex>
                            </mu-flex>
                            <mu-flex class="right_block_item" direction="column" ref="table_content">
                                <el-table :data="deviceCountData" :max-height="tableHeight" stripe class="custom_el_dark_table">
                                    <el-table-column
                                        prop="companyName"
                                        :label="$t('deviceMap.company')">
                                    </el-table-column>
                                    <el-table-column
                                        prop="deviceCount"
                                        :label="$t('deviceMap.number')"
                                        width="220"
                                        align="right">
                                    </el-table-column>
                                </el-table>
                            </mu-flex>
                        </mu-flex>
                    </mu-paper>
                </mu-col>
            </mu-row>
        </mu-container>
    </div>
</template>
<script>
import * as API from "@/api/device/deviceMap";
import * as animationData from "@/assets/lottie/earth-and-connections.json"
import IEcharts from "vue-echarts"
export default {
    name: "DeviceMap",
    data() {
        return {
            currentDate: new Date(),
            timer: null,
            mapLoaded: false,
            loadingPosition: true,
            bmap: null,
            insideMapHeight: '640px',
            registerDeviceList:[],
            notRegisterDeviceList:[],
            allDeviceCount:0,
            defaultOptions: {
                animationData: animationData,
                loop: true,
            },
            pieOption: {},
            deviceCountData: [],
            onlineCount: 0,
            offlineCount: 0,
            scrapCount: 0,
            maintainCount: 0,
            loseCount: 0,
            tableHeight: 120
        }
    },
    components: {IEcharts},
    mounted() {
        var self = this;
        this.timer = setInterval(() => {
            self.currentDate = new Date();
        }, 1000);
        this.removeScript();
        var self = this;
        this.$nextTick(function() {
            self.loadScript();
            var mapHeight = self.$refs.map_container.clientHeight + 50;
            self.insideMapHeight = mapHeight + "px";
            self.tableHeight = document.body.clientHeight / 4;

            setTimeout(() => {
                if (!self.mapLoaded) {
                  self.initMap();
                }
                API.getAllDevice({}).then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.registerDeviceList = res.data.registerDevice;
                        this.notRegisterDeviceList = res.data.notRegisterDevice;
                        this.allDeviceCount = this.registerDeviceList.length+this.notRegisterDeviceList.length;
                        this.initRegDevicePosition();
                        console.log("init over");
                        this.loadingPosition = false;
                        this.$forceUpdate();
                    }
                });
            }, 500);

            API.getCompanyCountInfo({}).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.deviceCountData = res.data;
                }
            });

            API.getAllOnlineStatusCount({}).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.onlineCount = res.data.online;
                    this.offlineCount = res.data.offline;
                    this.setPieOption({online: res.data.online, offline: res.data.offline});
                }
            });

            API.getAllStautsDevices({}).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.scrapCount = res.data.scrap;
                    this.maintainCount = res.data.maintain;
                    this.loseCount = res.data.lose;
                }
            })
        });
    },
    methods: {
        loadScript() {
            var systemInfo = this.systemInfo;
            let script = document.createElement("script");
            script.src =
            "https://api.map.baidu.com/getscript?v=2.0&ak=jaGo7PrOVcwy5c8wL7lGpbkYpkHpm7aS";
            script.id = 0;
            document.getElementsByTagName("body")[0].appendChild(script);
        },
        removeScript() {
            for (var i = 0; i < 5; i++) {
                if (document.getElementById(i) != null) {
                    document.getElementsByTagName("body")[0].removeChild(document.getElementById(i));
                }
            }
        },
        // 创建地图
        initMap() {
            console.log("initMap");
            var that = this;
            this.bmap = new BMap.Map(this.$refs.bmap, {
                enableMapClick: false
            });
            this.bmap.centerAndZoom(new BMap.Point(108.954355, 34.275636), 6);
            this.bmap.enableScrollWheelZoom(true);
            this.bmap.enableDragging();
            this.bmap.setMapStyle(
                {
                    'styleJson': [
                        {
                            'featureType': 'water',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#11121E'
                            }
                        },
                        {
                            'featureType': 'land',
                            'elementType': 'geometry',
                            'stylers': {
                                'color': '#181B2A'
                            }
                        },
                        {
                            'featureType': 'highway',
                            'elementType': 'all',
                            'stylers': {
                                'visibility': 'off'
                            }
                        },
                        {
                            'featureType': 'arterial',
                            'elementType': 'geometry.fill',
                            'stylers': {
                                'color': '#000000'
                            }
                        },
                        {
                            'featureType': 'arterial',
                            'elementType': 'geometry.stroke',
                            'stylers': {
                                'color': '#0b3d51'
                            }
                        },
                        {
                            'featureType': 'local',
                            'elementType': 'geometry',
                            'stylers': {
                                'color': '#000000'
                            }
                        },
                        {
                            'featureType': 'railway',
                            'elementType': 'geometry.fill',
                            'stylers': {
                                'color': '#000000'
                        }
                        },
                        {
                            'featureType': 'railway',
                            'elementType': 'geometry.stroke',
                            'stylers': {
                                'color': '#08304b'
                            }
                        },
                        {
                            'featureType': 'subway',
                            'elementType': 'geometry',
                            'stylers': {
                                'lightness': -70
                            }
                        },
                        {
                            'featureType': 'building',
                            'elementType': 'geometry.fill',
                            'stylers': {
                                'color': '#000000'
                            }
                        },
                        {
                            'featureType': 'all',
                            'elementType': 'labels.text.fill',
                            'stylers': {
                                'color': '#857f7f'
                            }
                        },
                        {
                            'featureType': 'all',
                            'elementType': 'labels.text.stroke',
                            'stylers': {
                                'color': '#000000'
                            }
                        },
                        {
                            'featureType': 'building',
                            'elementType': 'geometry',
                            'stylers': {
                                'color': '#022338'
                            }
                        },
                        {
                            'featureType': 'green',
                            'elementType': 'geometry',
                            'stylers': {
                                'color': '#062032'
                            }
                        },
                        {
                            'featureType': 'boundary',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#11121E'
                            }
                        },
                        {
                            'featureType': 'manmade',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#022338'
                            }
                        },
                        {
                            'featureType': 'label',
                            'elementType': 'all',
                            'stylers': {
                                'visibility': 'on'
                            }
                        }
                    ]
                }
            );
            this.mapLoaded = true;
            window.DeviceMap.mapLoadComplete = true;
        },

        // 初始化设备坐标
        initRegDevicePosition() {
            var self = this;
            var index = 0;
            this.bmap.clearOverlays();
            this.registerDeviceList.forEach(element => {
                var fillColor = '#68CB9A';
                var shadowColor = 'rgba(104, 203, 154, 0.3)';
                var statusStr = this.$t('device.online');
                var iconPath = "/mdm/static/images/ico_dot_green.png";
                if (element.online == 1) {
                    fillColor = '#68CB9A';
                    shadowColor = 'rgba(104, 203, 154, 0.3)';
                    statusStr = this.$t('device.online');
                    iconPath = "/mdm/static/images/ico_dot_green.png";
                } else if (element.online == 0) {
                    fillColor = '#E86666';
                    shadowColor = 'rgba(232, 102, 102, 0.3)';
                    statusStr = this.$t('device.offline');
                    iconPath = "/mdm/static/images/ico_dot_red.png";
                }
                if (element.status == 2){
                    fillColor = '#F0BF4A';
                    shadowColor = 'rgba(240, 191, 74, 0.3)';
                    statusStr = this.$t('deviceMap.maintain');
                    iconPath = "/mdm/static/images/ico_dot_yellow.png";
                }

                var myIcon = new BMap.Icon(iconPath, new BMap.Size(24,24));
                var mapPointer = new BMap.Point(element.gpsX, element.gpsY);
                var marker = new BMap.Marker(mapPointer, {icon:myIcon});
                self.bmap.addOverlay(marker);
                var sInfo = "<div style='float:left;width:224px;height:88px;display:block;'>" +
                                    "<p style='width:224px;float:left;font-size:12px;margin:4px 0px;'>"+this.$t('deviceMap.stauts')+": <span style='color:" + fillColor + ";font-size:14px;'>" + statusStr + "</span></p>" +
                                    "<p style='width:224px;float:left;font-size:12px;margin:4px 0px;'>"+this.$t('deviceMap.sn')+": <span style='color:68CB9A;font-size:14px;'>" + element.sn + "</span></p>" +
                                    "<p style='width:224px;float:left;font-size:12px;margin:4px 0px;'>"+this.$t('deviceMap.company')+": <span style='color:68CB9A;font-size:14px;'>" + element.companyName + "</span></p>" +
                                "</div>";
                var sContent = "<div style='width:100%;height:100px;'>" + sInfo + "</div></div>";
                var infoWindow = new BMap.InfoWindow(sContent, {
                    title: element.name,
                    width: 240
                });
                marker.addEventListener('click', function(event){
                    setTimeout(() => {
                        self.bmap.openInfoWindow(infoWindow, mapPointer);
                        //图片加载完毕重绘infowindow
                        if (document.getElementById('imgDemo')) {
                            document.getElementById('imgDemo').onload = function (){
                                infoWindow.redraw();
                            }
                        }
                    }, 800);
                });
            });
        },
        setPieOption(chartData) {
            this.pieOption = {
                color:['#68CB9A', '#E86666'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                series: [
                    {
                        name: this.$t('deviceMap.onlineStatus'),
                        type: 'pie',
                        radius: '86%',
                        center: ['50%', '50%'],
                        data: [
                            {value: chartData.online, name: this.$t('deviceMap.online')},
                            {value: chartData.offline, name: this.$t('deviceMap.offline')},
                        ],
                        label: {
                            show:true,
                            position: 'inside',
                            color: '#ffffff',
                            formatter: function(param) {
                                if (param.value == 0) {
                                    return "";
                                } else {
                                    return param.name + '\n' + param.value + ' (' + param.percent + '%)';
                                }
                            }
                        },
                        itemStyle: {
                            // color: '#5E77FF',
                            shadowBlur: 10,
                            shadowColor: 'rgba(94, 119, 255, 0.55)'
                        },
                        animationType: 'scale',
                        animationEasing: 'elasticOut',
                        animationDelay: function (idx) {
                            return Math.random() * 200;
                        }
                    }
                ]
            }
        },
    }
}
</script>
<style scoped>
#DeviceMap {
    height: 100vh;
    background-color: #11121E;
    background-image: url(/static/images/pic_header_bg.png);
    background-repeat: no-repeat;
    background-position: top;
    background-size: 100% auto;
}
.top_nav {
    height:56px;
    background: transparent;
}
.brand_info {
    margin-left: 254px;
}
.brand_info img {
    height:26px;
    width:auto;
}
.brand_info span {
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:22px;
    margin-left:8px;
}
.top_right {
    height:80%;
    margin:10% 0px;
    font-size:12px !important;
}
.top_right .mu-button {
    font-size:12px !important;
}
.current_date {
    font-size:14px;
    font-family:DINCOND;
    font-weight:bold;
    color:rgba(255,255,255,1);
    line-height:17px;
    margin-right:12px;
    margin-left:8px;
}
.divider_vert {
    width:1px;
    height:18px;
    margin:0px 8px;
    background:rgba(107,117,160,1);
}
.index_paper {
    background:rgba(25,27,47,1);
    border-radius:4px;
    height:calc(100vh - 62px);
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.4) 4px 0px 8px;
    position: relative;
}
.right_block_item {
    width:100%;
    height: 25%;
    padding:24px;
    padding-bottom:0px;
}
.play_value {
    height:100%;
}
.play_value .value {
    font-family: LCD-N;
    font-size:56px !important;
    margin:0px;
    line-height: 64px;
    color:#ffffff;
}
.play_value .label {
    font-size:12px;
    margin:0px;
    line-height: 18px;
    color:#6B75A0;
}
.linear_progress {
    margin: 4px 0px;
}
.sum_info p {
    margin-right:64px;
    color:#6B75A0;
    font-size:16px;
}
.sum_info p span {
    color:#ffffff;
    margin-left:4px;
    font-family: LCD-N;
}
.loading_block {
    border:2px solid rgba(22,24,42,1);
    background: #181B2A;
    position:absolute;
    top:0px;
    left:0px;
    right:0px;
    bottom:0px;
}
</style>
<style>
.BMap_bubble_title {
	color:white;
	font-size:14px;
	font-weight:bold;
    text-align:left;
    padding: 6px 8px;
	background-color:#5A6289;
    border-radius: 4px 4px 0px 0px;
}
/* 消息内容 */
.BMap_bubble_content {
	background-color: #6B75A0;
    padding: 6px 8px;
    color:white;
}
.BMap_bubble_content .map_board_footer a {
    font-size:12px !important;
    cursor: pointer !important;
    color:#6B75A0 !important;
    padding: 6px 12px;
    background:#222541;
}
.BMap_bubble_content .map_board_footer a img{
    width: auto;
    height: 12px;
    margin-right:8px;
    padding-top:4px;
}
.BMap_bubble_content .map_board_footer a:hover {
    color:#5E77FF !important;
}
/* 内容 */
.BMap_pop div:nth-child(9) {
	top:35px !important;
	border-radius:7px;
}
/* 左上角删除按键 */
.BMap_pop img {
	top:43px !important;
	left:238px !important;
}
.BMap_top {
	display:none;
}
.BMap_bottom {
	display:none;
}
.BMap_center {
	display:none;
}
.BMap_pop div:nth-child(1) div{
	display:none;
}
.BMap_pop div:nth-child(3) {
	display:none;
}
.BMap_pop div:nth-child(5) {
	display:none;
}
.BMap_pop div:nth-child(7) {
	display:none;
}
.custom_el_dark_table {
    background-color: #191B2F !important;
    /* border:1px solid rgba(66, 149, 209, 0.3); */
    border:0px !important;
    border-bottom: 0px;
}
.custom_el_dark_table th {
    color: #6B75A0;
    background-color: #222541 !important;
}
.custom_el_dark_table td {
    color:#6B75A0;
    border-bottom: 0px solid #EBEEF5 !important;
}
.custom_el_dark_table th.is-leaf {
    color: #FFFFFF;
    font-size:12px;
    font-weight: 400;
    height: 32px;
    border-bottom: 0px !important;
}
.custom_el_dark_table .el-table__body tr:hover>td {
    background-color: #191B2F !important;
    color:#ffffff !important;
}
.custom_el_dark_table .el-table__expand-icon {
    color:#6B75A0;
}
.custom_el_dark_table td .cell {
    color:#6B75A0;
    font-size: 12px !important;
    /* overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important; */
}
.custom_el_dark_table .el-table__body tr {
    background-color: #191B2F;
}
.custom_el_dark_table .el-table__body .el-table__row:hover{
    background-color: transparent;
}
.custom_el_dark_table .el-checkbox__inner{
    background:#11121E;
    border: 1px solid #6B75A0;
}
.custom_el_dark_table .el-table__body tr.el-table__row--striped td {
    background:#222541 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/DeviceMap.vue